import createFormSender from '../../modules/ajax-form-sender';
import createValidator from '../../modules/validator';

const SELECTOR = '.js-ajax-form';
const map = new WeakMap<HTMLFormElement, { sender: Record<string, any>; submitFn: (event: Event) => void }>();

const showSuccessMessage = (
    form: HTMLFormElement,
    message = 'Заявка успешно отправлена. Скоро мы с Вами свяжемся!',
) => {
    const successMessage = form.querySelector('.js-form-message__success');
    const successBlock = form.querySelector<HTMLElement>('.js-form-message--success');
    const failureBlock = form.querySelector<HTMLElement>('.js-form-message--failure');

    if (successBlock) {
        successBlock.hidden = false;
    }

    if (failureBlock) {
        failureBlock.hidden = true;
    }

    if (successMessage) {
        successMessage.textContent = message;
    }
};

const showFailureMessage = (form: HTMLFormElement, message = 'Ваша заявка не была отправлена. Попробуйте ещё раз.') => {
    const failureMessage = form.querySelector('.js-form-message__failure');
    const successBlock = form.querySelector<HTMLElement>('.js-form-message--success');
    const failureBlock = form.querySelector<HTMLElement>('.js-form-message--failure');

    if (successBlock) {
        successBlock.hidden = true;
    }

    if (failureBlock) {
        failureBlock.hidden = false;
    }

    if (failureMessage) {
        failureMessage.textContent = message;
    }
};

const showFormMessages = (form: HTMLFormElement) => {
    const messagesContainer = form.querySelector('.js-form-messages');
    messagesContainer?.classList.remove('form-messages--hidden');
};

const hideFormMessages = (form: HTMLFormElement) => {
    const messagesContainer = form.querySelector('.js-form-messages');
    const successBlock = form.querySelector<HTMLElement>('.js-form-message--success');
    const failureBlock = form.querySelector<HTMLElement>('.js-form-message--failure');

    messagesContainer?.classList.add('form-messages--hidden');

    setTimeout(() => {
        if (successBlock) {
            successBlock.hidden = true;
        }

        if (failureBlock) {
            failureBlock.hidden = true;
        }
    }, 300);
};

const clearAntispamInput = (form: HTMLFormElement) => {
    const checkInput = form.querySelector<HTMLInputElement>('input[name="check_val"]');
    if (checkInput) {
        checkInput.value = '';
    }
};

let bannerClose = (form: HTMLFormElement, banners: HTMLFormElement, btn: HTMLFormElement) => {};

async function init(container: Element | Document = document) {
    const forms = Array.from(container.querySelectorAll<HTMLFormElement>(SELECTOR));
    const banners = Array.from(container.querySelectorAll<HTMLFormElement>('.banner-box'));
    const bannerCloseBtn = Array.from(container.querySelectorAll<HTMLFormElement>('.banner-close'));
    let bannerClose = () => {
        banners.forEach((el) => {
            el.hidden = true;
        });
        bannerCloseBtn.forEach((el) => {
            el.removeEventListener('click', bannerClose);
        });
    };

    forms.forEach((form) => {
        const preloader = form.hasAttribute('data-preloader');

        let isSubmitting = false;
        const validator = createValidator(form, {
            scrollToInvalidInputOptions: {
                behavior: 'smooth',
                block: 'center',
                inline: 'center',
            },
        });

        const sender = createFormSender(form, {
            shouldClearInputs: true,
            onBeforeSend: () => {
                if (preloader) {
                    form.classList.add('is-loading');
                }
                clearAntispamInput(form);
            },
            onSuccess: ({ success, message }) => {
                if (success) {
                    showSuccessMessage(form, message);
                } else {
                    showFailureMessage(form, message);
                }
            },
            onError: () => {
                showFailureMessage(form, 'Ваша заявка не была отправлена. Попробуйте ещё раз.');
            },
            onComplete: () => {
                showFormMessages(form);
                banners.forEach(() => {
                    bannerCloseBtn.forEach((el) => {
                        el.addEventListener('click', bannerClose);
                    });
                });

                if (preloader) {
                    setTimeout(() => {
                        form.classList.remove('is-loading');
                    }, 500);
                }
            },
        });

        function submitFn(event: Event) {
            if (isSubmitting) return;
            event.preventDefault();

            const isFormValid = validator.validate();

            if (isFormValid) {
                isSubmitting = true;

                form.classList.add('is-load');

                sender.send().finally(() => {
                    isSubmitting = false;

                    form.classList.remove('is-load');
                });
            }
        }

        form.addEventListener('submit', submitFn);
        map.set(form, { sender, submitFn });
    });
}

function destroy(container: Element | Document = document) {
    const forms = Array.from(container.querySelectorAll<HTMLFormElement>(SELECTOR));

    forms.forEach((form) => {
        const data = map.get(form);

        if (data) {
            form.removeEventListener('submit', data.submitFn);
        }
    });
}

function getInstanceByElement(element: HTMLFormElement) {
    return map.get(element);
}

const _module = { init, destroy, getInstanceByElement };

export default _module;
